import { render, staticRenderFns } from "./FairInsurance.vue?vue&type=template&id=3a55a8e5&scoped=true"
import script from "./FairInsurance.vue?vue&type=script&lang=js"
export * from "./FairInsurance.vue?vue&type=script&lang=js"
import style0 from "./FairInsurance.vue?vue&type=style&index=0&id=3a55a8e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55a8e5",
  null
  
)

/* custom blocks */
import block0 from "./FairInsurance.vue?vue&type=custom&index=0&blockType=stlye&lang=scss"
if (typeof block0 === 'function') block0(component)

export default component.exports